import { useEffect } from "react";
import { gsap } from "gsap";

interface SkewXYAnimationProps {
    svgElement: SVGElement;
    skewAngle: number,
    animationSpeed: number;
  }

  const SkewXYAnimation: React.FC<SkewXYAnimationProps> = ({
    svgElement,
    skewAngle = 20,
    animationSpeed = 1,
  }) => {
    useEffect(() => {
      gsap.to(svgElement, {
        skewXY: skewAngle,
        duration: animationSpeed,
        ease: "power1.inOut",
        repeat: -1,
        yoyo: true,
      });
    }, [svgElement, skewAngle, animationSpeed]);
  
    return null;
  };
   
export default SkewXYAnimation;
